import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RAiFeature } from './r-ai-feature.action';

interface RAiFeatureXsStateModel{
  useAiFeatureRight: string;
}

const getDefaults = (): RAiFeatureXsStateModel => ({
  useAiFeatureRight: null,
});

@State<RAiFeatureXsStateModel>({
  name: 'rAiFeature',
  defaults: getDefaults()
})
@Injectable()
export class RAiFeatureXsState{

  //region SELECTOR
  @Selector()
  static canUseAiFeature(state: RAiFeatureXsStateModel): boolean {
    return state.useAiFeatureRight != null;
  }
  //endregion

  //region ACTIONS
  @Action(RAiFeature.SetAiPrivileges)
  public setAccessRightsPrivileges(ctx: StateContext<RAiFeatureXsStateModel>, action: RAiFeature.SetAiPrivileges) {
    const state = ctx.getState();
    const aiFeaturePrivileges = [...action.activeUserRightInfoDtoModel.aiFeaturePrivileges];

    //find user privilege data model
    const useAiFeaturePrivileges = aiFeaturePrivileges.find(id => id === UserPrivilegeEnum.USE_AI_FEATURES);

    //set the state
    ctx.setState({
      ...state,
      useAiFeatureRight: useAiFeaturePrivileges
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RAiFeatureXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion
}
